type StatusColor = 'default' | 'info' | 'errorAlt' | 'error' | 'success' | 'warning';

/**
 * Chip color for a generic admin status (DESIGN.md "Known generic-status conventions").
 * Input is trimmed and lowercased, so 'SYSTEM_PROBLEM' and 'Enabled' match; nullish or
 * blank input is 'default', and unrecognized statuses fall back to 'info'.
 *
 * These are Chip colors. 'default' has no palette entry, so callers building
 * `${color}.main` must special-case it (ChannelHeaderCard, the sales-channel daily-statuses
 * chart). 'errorAlt' is a custom palette role (src/theme/mui-augmentations.d.ts) that only
 * Chip accepts as a `color` prop.
 *
 * Trend direction is tracked separately in NEGATIVE_STATUSES (src/utils/delta-calculations.ts);
 * add a new status there too when an increase in it should read as a negative trend.
 */
export function statusColor(data: unknown): StatusColor {
  if (data == null) return 'default';
  const d = String(data).trim().toLowerCase();
  if (!d) return 'default';

  if (['deleted', 'draft', 'inactive', 'seller_deactivated', 'unlisted', 'unpublished'].includes(d)) return 'default';
  if (['retired'].includes(d)) return 'info';
  if (['suspended'].includes(d)) return 'errorAlt';
  if (['canceled', 'disabled', 'error', 'errored', 'killed', 'rejected', 'system_problem', 'unlist'].includes(d)) return 'error';
  if (['active', 'activate', 'approved', 'confirmed', 'done', 'enabled', 'listed', 'published', 'shipped', 'success'].includes(d)) return 'success';
  if (['incomplete', 'not_live', 'pending', 'platform_deactivated', 'partially_routed', 'zero'].includes(d)) return 'warning';

  return 'info';
}
